import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterDifficultySubcategoryLogic} from "./FilterDifficultySubcategory.logic";
import {CheckboxListItem} from "../../../components/common/checkbox/CheckboxListItem";

export interface IFilterDifficultySubcategoryProps {
  difficultyId: number;
}

export const FilterDifficultySubcategory: VoidFunctionComponent<IFilterDifficultySubcategoryProps> = ({difficultyId}) => {
  const {title, isSelected, handleToggleOnClick} = useFilterDifficultySubcategoryLogic(difficultyId);
  return (

    <CheckboxListItem
      label={`${title}`}
      onClick={handleToggleOnClick}
      isChecked={isSelected}
    />
  );
}

